import React from "react";
import { Facebook, Mail, Shield } from "lucide-react";

export default function Footer() {
  return (
    <footer
      style={{
        marginTop: "32px",
        background: "linear-gradient(135deg, rgba(15,23,42,0.95), rgba(10,12,24,0.9))",
        borderTop: "1px solid rgba(59,130,246,0.18)",
        boxShadow: "0 -10px 40px rgba(8,12,24,0.5)",
        zIndex: 10,
      }}
    >
      <div
        style={{
          maxWidth: "1400px",
          margin: "0 auto",
          padding: "20px 32px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          flexWrap: "wrap",
          gap: "16px",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
          <Shield
            size={24}
            style={{ color: "#fbbf24" }}
          />
          <div>
            <p
              style={{
                margin: 0,
                fontSize: "13px",
                fontWeight: 600,
                color: "#e2e8f0",
              }}
            >
              Powered by cloudrealtor.io
            </p>
            <p
              style={{
                margin: 0,
                fontSize: "11px",
                color: "#94a3b8",
              }}
            >
              Trusted by thousands of borrowers
            </p>
          </div>
        </div>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "20px",
          }}
        >
          <a
            href="https://www.facebook.com/profile.php?id=61583508268859"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: "flex",
              alignItems: "center",
              gap: "6px",
              padding: "8px 14px",
              borderRadius: "8px",
              background: "linear-gradient(135deg, #1877f2 0%, #0c63d4 100%)",
              color: "white",
              textDecoration: "none",
              fontSize: "12px",
              fontWeight: 600,
              transition: "transform 0.2s, box-shadow 0.2s",
              boxShadow: "0 2px 8px rgba(24,119,242,0.3)",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-2px)";
              e.currentTarget.style.boxShadow = "0 4px 12px rgba(24,119,242,0.4)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow = "0 2px 8px rgba(24,119,242,0.3)";
            }}
          >
            <Facebook size={16} />
            Follow Us
          </a>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "12px",
                fontSize: "12px",
                color: "#cbd5e1",
              }}
            >
              <a
                href="mailto:support@cloudrealtor.io"
                style={{
                display: "flex",
                alignItems: "center",
                gap: "4px",
                color: "#475569",
                textDecoration: "none",
                transition: "color 0.2s",
              }}
                onMouseEnter={(e) => (e.currentTarget.style.color = "#fbbf24")}
                onMouseLeave={(e) => (e.currentTarget.style.color = "#cbd5e1")}
              >
                <Mail size={14} />
                support@cloudrealtor.io
              </a>
            </div>
        </div>

        <div
          style={{
            fontSize: "11px",
            color: "#94a3b8",
            textAlign: "right",
          }}
        >
          <p style={{ margin: 0 }}>
            &copy; {new Date().getFullYear()} cloudrealtor.io
          </p>
          <p style={{ margin: 0 }}>All rights reserved</p>
        </div>
      </div>
    </footer>
  );
}
